var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoss = function SvgLoss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0086 0.0516148C12.5638 -0.0965273 12.0776 0.0821638 11.8393 0.485772C11.0958 1.74452 9.31158 4.78979 6.28178 10.0996C4.41918 13.3639 6.51087 16.182 9.46565 17.5508L6.47809 26.5628L3.37502 25.5341C2.85079 25.3603 2.28494 25.6444 2.11115 26.1686L2.05107 26.3498C1.87728 26.8741 2.16137 27.4399 2.6856 27.6137L11.0221 30.3773C11.5463 30.5511 12.1122 30.267 12.2859 29.7428L12.346 29.5616C12.5198 29.0373 12.2357 28.4715 11.7115 28.2977L8.53789 27.2456L11.5245 18.2365C14.7352 18.9186 18.1265 17.9025 18.5333 14.1611C18.6696 12.907 18.796 11.7617 18.9123 10.721L15.1978 9.9562L19.1808 8.34653C19.4497 5.99609 19.6444 4.38386 19.7627 3.42744L14.9755 7.15689L16.1798 1.10798L13.0086 0.0516148Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9668 15.5701L26.0642 20.1102L21.1016 20.7651L25.9668 15.5701Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7009 30.3826L18.3059 31.6345L16.3261 27.1241L22.7009 30.3826Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6537 26.8179L30.3669 22.5225L23.5157 25.0986L27.6537 26.8179Z",
    fill: "currentColor"
  })));
};
export default SvgLoss;